<template>
  <v-dialog v-model="show" max-width="700px">
    <template v-if="create" v-slot:activator="{ on }">
      <v-btn
        dark
        top
        left
        small
        color="success"
        v-on="on"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <template v-else v-slot:activator="{ on }">
      <v-btn
        color="primary first-button"
        dark
        small
        absolute
        top
        right
        fab
        v-on="on"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <ValidationObserver v-slot="{ handleSubmit }">
        <v-card-title>
          <span class="headline">{{ create ? 'Add' : 'Edit' }} title to marketplace</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <ValidationProvider name="code" rules="required" v-slot="{ errors }">
                  <v-select
                    v-model="editedTitle.title_id"
                    :items="titles"
                    item-value="id"
                    item-text="name"
                    label="Title"
                    placeholder="Select title"
                    outlined
                    dense
                    :error-messages="errors[0]"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider name="url" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="editedTitle.url"
                    label="Url"
                    placeholder="Enter url"
                    outlined
                    dense
                    :error-messages="errors[0]"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="handleSubmit(save)">Save</v-btn>
        </v-card-actions>
    </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    titles: {
      type: Array,
      required: true
    },
    create: {
      type: Boolean,
      default: () => (true)
    },
    title: {
      type: Object,
      default: () => ({
        title_id: null,
        url: null,
        default_language: null,
        images: []
      })
    }
  },
  data() {
    return {
      editedTitle: {
        title_id: null,
        url: null,
        default_language: null,
        images: []
      },
      defaultTitle: {
        title_id: null,
        url: null,
        default_language: null,
        images: []
      },
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set() {
        this.$emit('input', !this.value)
      }
    }
  },
  methods: {
    closeDialog() {
      this.show = false;
      this.editedTitle = Object.assign({}, this.defaultTitle);
    },
    save() {
      this.$emit('save', this.editedTitle);
      this.closeDialog();
    }
  },
  watch: {
    show(show) {
      if (!this.create && show) {
        this.editedTitle = Object.assign({}, this.title, { old_title_id: this.title.title_id });
      }
    }
  },
}
</script>

<style scoped>
  .v-btn--absolute.v-btn--right.first-button {
    right: 60px;
  }
</style>